<template>
<div class="modal fade" id="structureModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Structure de remboursement</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"  aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form  @submit.prevent="submit" method="post">
                        <div class="form-group">
                            <ckeditor :editor="editor" v-model="text" :config="editorConfig"></ckeditor>
                        </div>

                       <div class="form-group">
                            <label for="">Fichier PDF</label>
                            <input type="file" class="form-control" name="file" id="file" @change="pdfChange">
                       </div>
                       <div class="form-group">
                            <label for="">Fichier Excel</label>
                            <input type="file" class="form-control" name="file" id="file" @change="excelChange">
                       </div>
                       <div class="form-group">
                         <button class="btn btn-success" data-bs-dismiss="modal" type="submit"><i class="bx bi-save"></i> ENREGISTRER</button>
                       </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from "axios";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    export default{
        name:'StructureComponent',
        props:{
            dossier:{
                'type':Object,
                'required':true,
            }
        },
        data(){
            return {
                text:'',
                pdf:null,
                excel:null,
                editor: ClassicEditor,
                editorConfig: this.editorConfig,

            }
        },
        methods:{
            pdfChange(event){
                this.pdf = event.target.files[0];
            },
            excelChange(event){
                this.excel = event.target.files[0];
            },
            submit(){
                    let loader = this.$loading.show({
                        container: this.fullPage ? null : this.$refs.formContainer,
                        canCancel: false,
                    });
                    let form = new FormData();
                    if(this.pdf!=null){
                        form.append("pdf",this.pdf);
                    }
                    if(this.excel!=null){
                        form.append("excel",this.excel);
                    }
                    form.append("text",this.text);
                    form.append("id",this.dossier.id);
                    axios.post(this.path+'cga/pme/structure_remboursement',form,{
                        headers:{
                            'Accept':'multipart/form-data'
                        }
                    })
                    .then((res)=>{
                        console.log(res)
                        this.$emit('success');
                    })
                    .catch((err)=>{
                        this.$emit('error')
                        console.log(err)
                    })
                    .finally(()=>loader.hide())
                
            }
        },
        computed:{
        },
        watch:{
            dossier(newValue,oldValue){
                console.log(oldValue)
                console.log(newValue)
                this.text = this.dossier.structure_remboursement_text;
            }
        },
        mounted(){
            this.text = this.dossier.structure_remboursement_text;
        }
    }

</script>

<style scoped>


</style>